export default "__VITE_ASSET__1x$Y2WzR__"